import { RepairsView } from "@/features/repairs/components/RepairsView"

export default function RepairsPage() {
  return <RepairsView />
}